import { render, staticRenderFns } from "./SubscriptionOption.vue?vue&type=template&id=63904b62&scoped=true"
import script from "./SubscriptionOption.vue?vue&type=script&lang=js"
export * from "./SubscriptionOption.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionOption.vue?vue&type=style&index=0&id=63904b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63904b62",
  null
  
)

export default component.exports